import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Gallery from "@/components/Gallery";
import { Reveal, Overline } from "@/components/motion";
import { getGallery } from "@/lib/api";
import { IMAGES } from "@/data/demo";

const MatchsAmicaux = () => {
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    getGallery("matchs").then(setGallery);
  }, []);

  return (
    <div data-testid="matchs-amicaux-page">
      <PageHero
        testId="matchs-hero"
        contentKey="matchs"
        image={IMAGES.heroHome}
        overline="Professionnels & semi-professionnels"
        titleLines={[
          <span key="a" className="text-white">MATCHS</span>,
          <span key="b" className="text-gold">AMICAUX</span>,
        ]}
        subtitle="3M Match Pro organise vos matchs amicaux de A à Z : opposition de niveau, stade, arbitres, logistique et mise en scène. Vous jouez, nous nous occupons du reste."
      >
        <Link
          to="/contact?objet=Demande%20de%20devis%20—%20Match%20amical"
          data-testid="matchs-cta-devis"
          className="px-8 py-4 bg-rouge text-white text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-rouge-hover hover:scale-[1.02] active:scale-95 transition-all shadow-[0_0_24px_rgba(230,0,0,0.35)] inline-flex items-center gap-3"
        >
          Demander un devis <ArrowRight size={16} />
        </Link>
      </PageHero>

      {/* PRESENTATION */}
      <section data-testid="matchs-presentation" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-5">
            <Overline>Le service</Overline>
            <h2 className="mt-4 font-display uppercase text-4xl sm:text-5xl leading-[0.9] tracking-tight">
              Des matchs organisés <span className="text-gold">comme des affiches officielles</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7 space-y-5">
            <p className="text-white/70 leading-relaxed text-base md:text-lg">
              Clubs professionnels, semi-professionnels ou amateurs ambitieux : nous construisons des
              oppositions adaptées à votre niveau et à vos objectifs. Recherche d'adversaire, réservation
              du stade, corps arbitral, intendance, accueil des équipes : chaque détail est pris en charge.
            </p>
            <p className="text-white/70 leading-relaxed text-base md:text-lg">
              Notre terrain de jeu historique : la Côte d'Azur, ses infrastructures et son attractivité
              pour les clubs français et internationaux.
            </p>
          </Reveal>
        </div>
      </section>

      <div className="bg-[#0a0a0a] border-y border-white/5">
        <Gallery items={gallery} title="Nos matchs en images" overline="Galerie photos & vidéos" testId="gallery-matchs" />
      </div>

      {/* CTA DEVIS */}
      <section data-testid="matchs-cta" className="relative px-6 md:px-12 lg:px-24 py-28 md:py-40 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.stadiumAerial} alt="" loading="lazy" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#050505]/85" />
        </div>
        <Reveal className="relative z-10 text-center max-w-3xl mx-auto">
          <Overline className="text-center">Votre prochain match commence ici</Overline>
          <h2 className="mt-4 font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.88] tracking-tight">
            Organisons votre <span className="text-gold">match</span>
          </h2>
          <p className="mt-6 text-white/70 leading-relaxed">
            Dites-nous qui vous êtes, votre niveau et vos dates : nous revenons vers vous avec une
            proposition complète et un devis détaillé.
          </p>
          <Link
            to="/contact?objet=Demande%20de%20devis%20—%20Match%20amical"
            data-testid="matchs-cta-devis-bottom"
            className="mt-10 inline-flex items-center gap-3 px-10 py-5 bg-rouge text-white text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-rouge-hover hover:scale-[1.02] active:scale-95 transition-all shadow-[0_0_28px_rgba(230,0,0,0.4)]"
          >
            Demander un devis <ArrowRight size={16} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
};

export default MatchsAmicaux;
